import { render } from "./Home.vue?vue&type=template&id=fadd51dc&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=fadd51dc&lang=less"

import exportComponent from "/Users/julianzeng/Desktop/Buz/mainland/fuwangleyou-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__